import { convertThetaPhiToLatLng } from "@common/utils/UnitConverter";
import Feature from "../common/Feature";
import SourceLayer from "../common/SourceLayer";
export default class AirportSourceLayer extends SourceLayer {
    constructor(id, imageId, airports) {
        const features = airports.map((airport) => {
            const { lat, lng } = convertThetaPhiToLatLng(airport.theta, airport.phi);
            return new Feature(airport.icao, lat, lng, 0);
        });
        super(id, imageId, features);
    }
}
